import { useEffect, useState } from 'react'
import { supabase } from './supabase'

// Consumer-side reader for admin-managed feature flags (§10). Each call is a single
// key read against the public-readable app_settings table — no broader wiring.
export async function getAppFlag<T = unknown>(key: string): Promise<T | null> {
  const { data } = await supabase.from('app_settings').select('value').eq('key', key).maybeSingle()
  return (data?.value ?? null) as T | null
}

export function useAppFlag<T = unknown>(key: string, fallback: T): T {
  const [val, setVal] = useState<T>(fallback)
  useEffect(() => {
    let active = true
    getAppFlag<T>(key).then(v => { if (active && v !== null) setVal(v) })
    return () => { active = false }
  }, [key])
  return val
}
